import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-box _mb-6",
  "data-qa": "basic-contact-box"
}
const _hoisted_2 = {
  class: "gfu-hd gfu-hd--h1 _mb-4 _pt-2",
  "data-qa": "contact-form-title"
}
const _hoisted_3 = {
  class: "gfu-filters",
  "data-qa": "contact-form-option:ProjectSearch"
}
const _hoisted_4 = { class: "gfu-hd gfu-hd--h4 _mt-3" }
const _hoisted_5 = {
  key: 1,
  class: "gfu-issue__no-results _mt-1",
  "data-qa": "contact-form:Searching"
}
const _hoisted_6 = {
  key: 2,
  class: "gfu-issue__no-results _mt-1",
  "data-qa": "contact-form:NoProjectFound"
}
const _hoisted_7 = {
  class: "gfu-hd gfu-hd--h4 _mt-3",
  "data-qa": "contact-form-title"
}
const _hoisted_8 = {
  class: "gfu-box",
  "data-qa": "business-contact-box"
}
const _hoisted_9 = {
  class: "gfu-hd gfu-hd--h1 _mb-4",
  "data-qa": "contact-form-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_issue_card = _resolveComponent("issue-card")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.Contact.TopicsSectionHeader), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_field, {
          modelValue: $data.searchTerm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchTerm) = $event)),
          class: "gfu-flex__item--grow _mt-0",
          placeholder: _ctx.Resources.Contact.ContactSearchFormPlaceholder,
          "display-name": _ctx.Resources.Contact.ContactSearchFormName,
          "auto-complete": "off"
        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "display-name"])
      ]),
      _createElementVNode("h3", _hoisted_4, _toDisplayString($data.searchTerm.length === 0 ? _ctx.Resources.Contact.ContactSearchSuggestedTitle : _ctx.Resources.Contact.ContactSearchResultsTitle), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.projectsCategoryGroups, (project) => {
        return (_openBlock(), _createBlock(_component_issue_card, {
          key: `project-${project.projectID}`,
          header: project.name,
          "image-url": project.thumbImageUrl,
          subtitle: _ctx.Resources.format(_ctx.Resources.Contact.ContactSearchResultByCreatorLabel, project.creator.name),
          onHeaderClick: $event => ($options.selectProject(project)),
          "data-qa": `issue-card-project:${project.projectID}`
        }, null, 8 /* PROPS */, ["header", "image-url", "subtitle", "onHeaderClick", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */)),
      ($data.canLoadMore && !$data.searchTerm.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "gfu-contact-more gfu-btn gfu-btn--block gfu-btn--light-alt _mt-3",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.loadRelevantProjectsPromise && $options.loadRelevantProjectsPromise(...args))),
            "data-qa": "contact-form-option:LoadMore"
          }, [
            _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton) + " ", 1 /* TEXT */),
            _createVNode(_component_base_icon, {
              name: "angle-down",
              size: "2x",
              class: "_tc--accent _ml-1 _tvam"
            })
          ]))
        : _createCommentVNode("v-if", true),
      ($data.isSearching)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Contact.ContactSearchInProgressLabel), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (!$data.isSearching && $options.projectsCategoryGroups.length === 0 && $data.searchTerm.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Contact.ContactSearchNoResultsParagraph), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.Resources.Contact.OtherIssuesSectionHeader), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.othersCategoryGroups, (categoryGroup) => {
        return (_openBlock(), _createBlock(_component_issue_card, {
          key: `categoryGroup-${categoryGroup.value}`,
          header: categoryGroup.displayName,
          onHeaderClick: $event => ($options.selectGroup(categoryGroup)),
          "data-qa": `contact-form-option:${categoryGroup.displayName}`
        }, null, 8 /* PROPS */, ["header", "onHeaderClick", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.Resources.Contact.BusinessContactSectionHeader), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.businessCategoryGroups, (categoryGroup) => {
        return (_openBlock(), _createBlock(_component_issue_card, {
          key: `categoryGroup-${categoryGroup.value}`,
          header: categoryGroup.displayName,
          onHeaderClick: $event => ($options.selectGroup(categoryGroup)),
          "data-qa": `contact-form-option:${categoryGroup.displayName}`
        }, null, 8 /* PROPS */, ["header", "onHeaderClick", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(_component_progress_overlay, {
      sticky: true,
      visible: _ctx.isProcessing
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}